import ControlFactory from '@/Factories/ControlFactory';
import AssociationSingleDropDownViewModel from '@/ViewModels/Controls/AssociationSingleDropDownViewModel';
import AssociationSingleDropDown from '@/Controls/AssociationSingleDropDown';
import ControlViewModel from '@/ViewModels/ControlViewModel';
import { IRefreshable } from '#/DefaultViewExtensionInterfaces';
import { IControlViewModelConstructorParameter } from '#/CoreFrameInterfaces';
import AssociationSingleDropDownViewModelT from '@/ViewModels/Controls/AssociationSingleDropDownViewModel';
import DropDownListViewModelT from '@/ViewModels/Controls/DropDownListViewModel';
import LinkViewModelT from '@/ViewModels/Controls/LinkViewModel';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import NavigationService from '@/Management/NavigationService';
import RADApplication from '@/Management/RADApplication';
import Config from '@/Management/GlobalConfiguration';
import ComponentManager from '@/Management/ComponentManager';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import Loader from '@/Utility/Loader';
import FilterHelper from '@/Utility/FilterHelper';
import LocatorHelper from '@/Utility/LocatorHelper';
import Utilities from '@/Utility/Utilities';
export default class AssociationSingleDropDownFactory extends ControlFactory implements IRefreshable {
    /** @overrides */
    public control: AssociationSingleDropDown;
    /** @overrides */
    public viewModel: AssociationSingleDropDownViewModel;
    protected jQueryControl: JQuery;
    /** @overrides */
    public orderStatement: string;
    public lazyLoading: boolean;
    public isOpen: boolean;
    public objectIdentValue: any;
    public pdoId: any;
    public forceReloadData: any;
    public iterator: any;
    public isModalCreating: any;
    private dataLoaded: any;
    private AssociationSingleDropDownViewModel: any;
    private AssociationSingleDropDown: any;
    private ObjectConnectionHelper: any;
    private ObjectDisconnectionHelper: any;
    private ObjectDeletionHelper: any;
    private ObjectCreationHelper: any;
    private _objectHelper: any;
    private DropDownListViewModel: any;
    protected LinkViewModel: any;
    protected ImageViewModel: any;
    protected LabelViewModel: any;
    private _disconnectId: any;
    constructor(protected params: any) {
        super(params);
        this.dataLoaded = this.observableOrDefault(false);
        this.AssociationSingleDropDownViewModel = ComponentManager.getViewModel<typeof AssociationSingleDropDownViewModelT>('AssociationSingleDropDownViewModel');
        this.AssociationSingleDropDown = ComponentManager.getControl('AssociationSingleDropDown');
        this.ObjectConnectionHelper = ComponentManager.getUtility('ObjectConnectionHelper');
        this.ObjectDisconnectionHelper = ComponentManager.getUtility('ObjectDisconnectionHelper');
        this.ObjectDeletionHelper = ComponentManager.getUtility('ObjectDeletionHelper');
        this.ObjectCreationHelper = ComponentManager.getUtility('ObjectCreationHelper');
        this._objectHelper = null;
        this.DropDownListViewModel = ComponentManager.getViewModel<typeof DropDownListViewModelT>('DropDownListViewModel');
        this.LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelT>('LinkViewModel');
        this.ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
        this.LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
        this.objectIdentValue = this.context.genericObject.getObservable(this.detailViewItem.name + '.ObjectIdentValue');
        this.pdoId = this.context.genericObject.getObservable(this.detailViewItem.name + '.PDO_ID');
        this.forceReloadData = false;
        this.iterator = null;
        this.isModalCreating = this.paramOrDefault(params.isModalCreating, false);
        this._disconnectId = null;
    }
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        // falls kein this.orderStatement �bergeben wird, wird sp�ter nach ObjectIdentValue sortiert
        this.orderStatement = this.paramOrDefault(this.params.orderStatement, '');
        this.lazyLoading = this.paramOrDefault(this.params.lazyLoading, false);
        this.isOpen = this.paramOrDefault(this.params.isOpen, false);
        this.context.genericObject.suppressNotificationFor(this.detailViewItem.name + '.PDO_ID');
        this.context.genericObject.suppressNotificationFor(this.detailViewItem.name + '.ObjectIdentValue');
        this.viewModel = this.createViewModel();
        let isAddingDummies = false;
        this.defineSubscription(this.viewModel.dropDownList.data,
            (data) => {
                if (isAddingDummies || Utilities.isNullOrUndefined(this.pdoId()))
                    return;
                isAddingDummies = true;
                if (Utilities.isNullOrUndefined(data))
                    data = [];
                // Bereits hiinzugefügte Dummies initial entferne
                data = data.filter((d) => { return d.dummy === false; });
                let found = _.find(data, (item) => { return item['pdoId'] === this.pdoId(); });
                if (!found) {
                    let newItem = {
                        pdoId: this.pdoId(),
                        objectIdentValue: this.objectIdentValue(),
                        dummy: true
                    };
                    data.push(newItem);
                    this.viewModel.dropDownList.data(data);
                }
                isAddingDummies = false;
            })();
        this.control = (() => {
            return new this.AssociationSingleDropDown(this.viewModel);
        })();
        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;
        this.registerObservableValidation(this.pdoId);
        return this.jQueryControl;
    }
    public notifyDetailViewClosed(topdTypeName?: any, toPDOID?: any): void {
        // Die Daten werden nicht geladen, wenn Lazy eingestellt ist. Dies muss aber erzwungen werden, damit die Daten aktualisiert werden wenn ein neues Element
        // erstellt und direkt verbunden wird.
        if (this.lazyLoading)
            this.isOpen = true;
        this.viewModel.dropDownList.data.evaluate();
        RADEnvironmentProxy.getInstance().getPropertiesForDetailViewContext({
            detailViewContextID: this.context.id,
            pdoID: this.context.genericObject.pdoId,
            properties: [this.detailViewItem.name + '.ObjectIdentValue', this.detailViewItem.name + '.PDO_ID']
        }).then((properties) => {
            if (this.validateStatus(properties)) {
                let oldPdoID = this.pdoId();
                let newPdoID = properties.returnValue[this.detailViewItem.name + '.PDO_ID'];
                this.pdoId(newPdoID);
                this.objectIdentValue(properties.returnValue[this.detailViewItem.name + '.ObjectIdentValue']);
                if (oldPdoID != newPdoID) {
                    this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                    this.context.notifyFactoryRefreshed(this.detailViewItem);
                }
            }
        });
    }
    /** @overrides */
    protected disposeInternal(): void {
        this.deleteIterator();
        super.disposeInternal();
    }
    
    public createViewModelParameter(): any {
        return {
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            isBusy: this.isBusy,
            technicalName: this.detailViewItem.name,
            dropDownList: new this.DropDownListViewModel({
                value: this.pdoId,
                parentLocator: this.locator,
                locator: this.detailViewItem.name,
                invalidationText: this.invalidationText,
                data: this.defineAsyncComputed(() => {
                    if (this.lazyLoading && !this.isOpen && !this.forceReloadData) {
                        return [];
                    }
                    this.isBusy(true);
                    this.deleteIterator();
                    this.forceReloadData = false;
                    let ret = RADEnvironmentProxy.getInstance().createIteratorWithOperator({
                        pdTypeName: this.detailViewItem.listView.typeName,
                        properties: ['ObjectIdentValue'],
                        filter: JSON.stringify(FilterHelper.createFilterObjectForStaticFilter(this.detailViewItem.listView.staticFilterExpression)),
                        orderby: this.convertOrderStatementWithoutAssociation(this.orderStatement),
                        retrieveExtentCount: true,
                        contextPDO_ID: this.context.genericObject.pdoId,
                        itOperator: {
                            includeAllPrincipals: this.detailViewItem.listView.includeAllPrincipals,
                            includeBasePrincipals: this.detailViewItem.listView.includeBasePrincipals,
                            includeSubPrincipals: this.detailViewItem.listView.includeSubPrincipals,
                            memoryOptimizationEnabled: true,
                            onlySubPrincipals: null,
                            historizationDates: null,
                            isGridIterator: null,
                            principalFilter: null,
                            searchObjectPositionRequest: null,
                            visibleDeletedObjects: null,
                            hideConnectedElementsRequest: null
                        }
                    }).then((iterator) => {
                        this.iterator = iterator;
                        if (this.iterator.extentCount > 0) {
                            return RADEnvironmentProxy.getInstance().getExtentWithPDOIDAsFirstColumn({
                                iteratorID: this.iterator.id,
                                start: 0,
                                end: this.iterator.extentCount - 1
                            });
                        }
                        return [];
                    }).then((arrayOfGeneric) => {
                        if (this.isDisposed !== false || arrayOfGeneric == null)
                            return undefined;

                        let result = [];
                        if (this.detailViewItem && this.detailViewItem.listView.showButtonDisconnect || !this.pdoId()) {
                            result.push({pdoId: '', objectIdentValue: ' ', locator: '__empty__', dummy: false});
                        }
                        // wenn kein this.orderStatement �bergeben wurde, wird jetzt nach ObjectIdentValue sortiert.
                        if (this.orderStatement === '') {
                            arrayOfGeneric = arrayOfGeneric.sort((a, b) => {
                                if (a[1].toLowerCase() < b[1].toLowerCase())
                                    return -1;
                                if (a[1].toLowerCase() > b[1].toLowerCase())
                                    return 1;
                                return 0;
                            });
                        }
                        for (let i = 0; i < arrayOfGeneric.length; i++) {
                            result.push({
                                pdoId: arrayOfGeneric[i][0],
                                objectIdentValue: arrayOfGeneric[i][1],
                                dummy: false
                            });
                        }
                        return result;
                    }).then((result) => {
                        if (this.isDisposed === false) {
                            this.async(() => {
                                if (this.viewModel != null) {
                                    this.viewModel.dropDownList.value.notifySubscribers();
                                }
                            });
                            this.isBusy(false);
                        }
                        return result;
                    });
                    ret.always(() => {
                        if (!this.isDisposed)
                            this.dataLoaded(true)
                    });
                    return ret;
                }, [{ pdoId: this.pdoId(), objectIdentValue: this.objectIdentValue() || ' ', locator: this.objectIdentValue() || '__empty__' }]),
                dataTextField: 'objectIdentValue',
                dataValueField: 'pdoId',
                onOpen: () => {
                    if (this.isOpen === false) {
                        this.isOpen = true;
                        if ((this.lazyLoading && !this.dataLoaded() || !Utilities.isNullOrUndefinedOrBlank(this.detailViewItem.listView.staticFilterExpression)) && !this.isBusy()) {
                            return this.viewModel.dropDownList.data.evaluate();
                        } else {
                            return Utilities.resolveImmediately(null);
                        }
                    }
                    return Utilities.resolveImmediately(null);
                },
                onClose: () => {
                    if (this.isDisposed === false && this.isOpen === true) {
                        this.isOpen = false;
                    }
                },
                onChange: (pdoId) => {
                    if (pdoId) {
                        this.OnConnection([pdoId]);
                    }
                },
                onSelect: (pdoId) => {
                },
                onUnselect: (pdoId) => {
                    this.OnDisconnection();
                },
                isEnabled: this.isEnabled,
                isFocusable: this.isFocusable,
                isValid: this.isValid,
                tooltip: new this.LabelViewModel({
                    ergName: this.detailViewItem.tooltip
                })
            }),
            linkCreate: new this.LinkViewModel({
                parentLocator: this.locator,
                locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.create'),
                tooltip: new this.LabelViewModel({
                    ergName: 'CREATE_NEW_AND_CONNECT_TOOLTIP'
                }),
                image: new this.ImageViewModel({
                    source: Config.inlineImages.OBJ_CREATE,
                    alternativeText: new this.LabelViewModel({
                        ergName: 'CREATE_NEW_AND_CONNECT_TOOLTIP'
                    })
                }),
                onClick: () => {
                    if (!this.IsValidItemSelected()) {
                        this.context.createContext(this, this.detailViewItem.listView, null, null, null, null, this.isModalCreating);
                    }
                    else {
                        let contextPdoId = this.context.genericObject.pdoId;
                        let associationName = this.detailViewItem.listView.relationName;
                        let pdTypeName = this.detailViewItem.listView.typeName;
                        this._objectHelper = new this.ObjectCreationHelper({
                            contextPdoId: contextPdoId,
                            associationName: associationName,
                            pdTypeName: pdTypeName,
                            affectedObjectIds: [this.pdoId()],
                            creationCallback: () => {
                                this.context.createContext(this, this.detailViewItem.listView, null, null, null, null, this.isModalCreating);
                            },
                            confirmDeletionCallback: this.OnConfirmDeletionCallback.bind(this)
                        });
                        this._objectHelper.ExecuteCheck();
                    }
                },
                isVisible: this.defineComputed(() => {
                    return this.isEnabled() && this.detailViewItem.listView.showButtonCreate;
                }),
                isFocusable: this.isFocusable,
                isToolBarLink: true,
                isEnabled: this.isEnabled
            }),
            linkEdit: new this.LinkViewModel({
                parentLocator: this.locator,
                locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.edit'),
                tooltip: new this.LabelViewModel({
                    ergName: 'EDIT_CONNECTED_TOOLTIP'
                }),
                image: new this.ImageViewModel({
                    source: Config.inlineImages.OBJ_EDIT,
                    alternativeText: new this.LabelViewModel({
                        ergName: 'EDIT_CONNECTED_TOOLTIP'
                    })
                }),
                isEnabled: this.defineComputed(() => {
                    return this.pdoId() != null && this.pdoId() != this.detailViewItem.disableNavigation;
                }),
                onClick: () => {
                    this.context.createContext(this, this.detailViewItem.listView, this.pdoId());
                },
                isFocusable: this.isFocusable,
                isVisible: this.detailViewItem.listView.showButtonEdit,
                isToolBarLink: true
            }),
            linkDelete: new this.LinkViewModel({
                parentLocator: this.locator,
                locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.delete'),
                tooltip: new this.LabelViewModel({
                    ergName: 'DISCONNECT_AND_DELETE_TOOLTIP'
                }),
                image: new this.ImageViewModel({
                    source: Config.inlineImages.OBJ_DELETE,
                    alternativeText: new this.LabelViewModel({
                        ergName: 'DISCONNECT_AND_DELETE_TOOLTIP'
                    })
                }),
                isEnabled: this.defineComputed(() => {
                    return this.isEnabled() && this.pdoId() != null;
                }),
                onClick: () => {
                    if (this.IsValidItemSelected()) {
                        let pdTypeName = this.detailViewItem.listView.typeName;
                        let associationName = this.detailViewItem.listView.relationName;
                        let deletionHelper = new this.ObjectDeletionHelper({
                            pdTypeName: pdTypeName,
                            affectedObjectIds: [this.pdoId()],
                            confirmDeletionCallback: this.OnConfirmDeletionCallback.bind(this)
                        });
                        deletionHelper.ExecuteCheck();
                    }
                },
                isVisible: this.defineComputed(() => {
                    return this.isEnabled() && this.detailViewItem.listView.showButtonDelete;
                }),
                isFocusable: this.isFocusable,
                isToolBarLink: true
            }),
            disconnectItem: this.OnDisconnection.bind(this)
        }
    }
    public createViewModel(): AssociationSingleDropDownViewModel {
        return new this.AssociationSingleDropDownViewModel(this.createViewModelParameter());
    }
    /** @implements */
    public refresh(): void {
        this.refreshAssociation();
    }
    public getValueForFilter(): any {
        let ret = {};
        ret[this.detailViewItem.name + '.ObjectIdentValue'] = this.objectIdentValue();
        ret[this.detailViewItem.name + '.PDO_ID'] = this.pdoId();
        return ret;
    }
    public getFilterInfo(): any {
        return {
            field: this.detailViewItem.name + '.PDO_ID',
            value: this.pdoId() || ''
        };
    }
    public resetValue(): any {
        this.pdoId(null);
    }
    public refreshAssociation(): any {
        this.forceReloadData = true;
        this.viewModel.dropDownList.data.evaluate();
        this.context.genericObject.refreshProperties([this.detailViewItem.name + '.ObjectIdentValue', this.detailViewItem.name + '.PDO_ID']);
    }
    public deleteIterator(): any {
        if (this.isDisposed) {
            return;
        }
        let iterator = this.iterator;
        if (iterator != null) {
            RADEnvironmentProxy.getInstance().deleteIterator({
                iteratorID: iterator.id
            });
        }
    }
    private OnDisconnection(): any {
        if (this.IsValidItemSelected()) {
            this._disconnectId = this.pdoId();
            let disconnectionHelper = new this.ObjectDisconnectionHelper({
                contextPdoId: this.context.genericObject.pdoId,
                associationName: this.detailViewItem.listView.relationName,
                pdTypeName: this.detailViewItem.listView.typeName,
                affectedObjectIds: [this._disconnectId],
                disconnectionCallback: this.OnDisconnectionCallback.bind(this),
                confirmDeletionCallback: this.OnConfirmDeletionCallback.bind(this)
            });
            disconnectionHelper.ExecuteCheck();
        }
    }
    private OnDisconnectionCallback = () => {
        if (!this._disconnectId) {
            return;
        }
        $.when(this.context.notifyBeforeUpdatedAssociation(this.detailViewItem.listView.relationName, 'disconnect', { toPdoIds: [this._disconnectId] }))
            .then((doUpdateAssociation) => {
                if (doUpdateAssociation == null || doUpdateAssociation === true) {
                    Loader.getInstance().show();
                    RADEnvironmentProxy.getInstance().disconnect({
                        pdoID: this.context.genericObject.pdoId,
                        assoziationName: this.detailViewItem.listView.relationName,
                        topdTypeName: this.detailViewItem.listView.typeName,
                        toPDOID: this._disconnectId,
                        nestedContextName: this.context.getNestedContextPath()
                    }).then((changeObject) => {
                        if (this.validateStatus(changeObject)) {
                            this.pdoId(null);
                            this.objectIdentValue(null);
                            this.context.genericObject.isModified(true);
                            this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                            this.context.notifyFactoryRefreshed(this.detailViewItem);
                        } else {
                            this.refreshAssociation();
                        }
                    }).always(() => {
                        this._disconnectId = null;
                        Loader.getInstance().hide();
                    });
                }
            });
    }
    private OnConnection = (toPDOIDs: any) => {
        if (+this.context.genericObject.pdoId > 0) {
            let selPdoId = toPDOIDs[0];
            if (!this.IsValidItemSelected()) {
                this.OnConnectionCallback(selPdoId);
            }
            else {
                let currentItem = [this.pdoId()];
                let associationName = this.detailViewItem.listView.relationName;
                let pdTypeName = this.detailViewItem.listView.typeName;
                this._objectHelper = new this.ObjectConnectionHelper({
                    contextPdoId: this.context.genericObject.pdoId,
                    associationName: associationName,
                    pdTypeName: pdTypeName,
                    affectedObjectIds: currentItem,
                    objectIdToConnect: selPdoId,
                    connectionCallback: this.OnConnectionCallback.bind(this),
                    confirmDeletionCallback: this.OnConfirmDeletionCallback.bind(this)
                });
                this._objectHelper.ExecuteCheck();
            }
        }
        else {
            this.viewModel.dropDownList.data.evaluate();
        }
    }
    private OnConnectionCallback(objectIdToConnect: any): any {
        $.when(this.context.notifyBeforeUpdatedAssociation(this.detailViewItem.listView.relationName, 'connect', { toPdoIds: [objectIdToConnect] }))
            .then((doUpdateAssociation) => {
                if (doUpdateAssociation == null || doUpdateAssociation === true) {
                    Loader.getInstance().show();
                    let contextId = this.context.genericObject.pdoId;
                    if (+contextId > 0) {
                        RADEnvironmentProxy.getInstance().connect({
                            pdoID: contextId,
                            assoziationName: this.detailViewItem.listView.relationName,
                            topdTypeName: this.detailViewItem.listView.typeName,
                            toPDOID: objectIdToConnect,
                            nestedContextName: this.context.getNestedContextPath()
                        }).then((changeObject) => {
                            if (this.validateStatus(changeObject)) {
                                this.pdoId(objectIdToConnect);
                                this.objectIdentValue(changeObject.returnValue);
                                // Remove possible empty entries
                                this.forceReloadData = true;
                                this.viewModel.dropDownList.data.evaluate();
                                this.context.genericObject.isModified(true);
                                this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                                this.context.notifyFactoryRefreshed(this.detailViewItem);
                            } else {
                                this.refreshAssociation();
                            }
                        }).always(() => {
                            Loader.getInstance().hide();
                            this.RemoveObjectHelper();
                        });
                    } else {
                        RADEnvironmentProxy.getInstance().getObject({
                            pdTypeName: this.detailViewItem.listView.typeName,
                            pdoID: objectIdToConnect,
                            properties: ['ObjectIdentValue']
                        }).then((genericDTO) => {
                            this.pdoId(objectIdToConnect);
                            this.objectIdentValue(genericDTO.objectIdentValue);
                        }).always(() => {
                            Loader.getInstance().hide();
                            this.RemoveObjectHelper();
                        });
                    }
                }
            });
    }
    private OnConfirmDeletionCallback(dialogResult: any): any {
        if (dialogResult === true) {
            if (this.IsValidItemSelected()) {
                let associationName = this.detailViewItem.listView.relationName;
                $.when(this.context.notifyBeforeUpdatedAssociation(associationName, 'disconnectAndDelete', { toPdoIds: [this.pdoId()] }))
                    .then((doUpdateAssociation) => {
                        if (doUpdateAssociation == null || doUpdateAssociation === true) {
                            Loader.getInstance().show();
                            let pdTypeName = this.detailViewItem.listView.typeName;
                            RADEnvironmentProxy.getInstance().deleteObject({
                                pdTypeName: pdTypeName,
                                pdoID: this.pdoId()
                            }).then((changeObject) => {
                                if (this.validateStatus(changeObject)) {
                                    this.pdoId(null);
                                    this.objectIdentValue(null);
                                    this.context.genericObject.isModified(true);
                                    this.context.notifyUpdatedAssociation(associationName);
                                    this.context.notifyFactoryRefreshed(this.detailViewItem);
                                    if (this._objectHelper) {
                                        this._objectHelper.ExecuteAction();
                                    }
                                }
                            }).always(() => {
                                this.refreshAssociation();
                                this.RemoveObjectHelper();
                                Loader.getInstance().hide();
                            });
                        }
                    });
            }
        }
        else {
            this.RemoveObjectHelper();
        }
    }
    private IsValidItemSelected(): any {
        return this.pdoId() && this.pdoId() >= 0;
    }
    
    private RemoveObjectHelper(): any {
        if (this._objectHelper && !this._objectHelper.isDisposed) {
            this._objectHelper.dispose();
            this._objectHelper = null;
        }
    }
}

ComponentManager.setFactory('AssociationSingleDropDown', AssociationSingleDropDownFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('AssoziationDropDown', AssociationSingleDropDownFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');